var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c("studip-dialog", {
        attrs: {
          title: _vm.$gettext("Feedback erstellen"),
          confirmText: _vm.$gettext("Erstellen"),
          closeText: _vm.$gettext("Schließen"),
          closeClass: "cancel",
          confirmClass: "accept",
          height: "420",
          width: "500",
        },
        on: {
          confirm: _vm.createFeedback,
          close: function close($event) {
            return _vm.$emit("close")
          },
        },
        scopedSlots: _vm._u([
          {
            key: "dialogContent",
            fn: function fn() {
              return [
                _c(
                  "form",
                  {
                    staticClass: "default",
                    on: {
                      submit: function submit($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c("label", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$gettext("Frage")) +
                          "\n                    "
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.question,
                            expression: "question",
                          },
                        ],
                        attrs: {
                          type: "text",
                        },
                        domProps: {
                          value: _vm.question,
                        },
                        on: {
                          input: function input($event) {
                            if ($event.target.composing) return
                            _vm.question = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("label", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$gettext("Beschreibung")) +
                          "\n                    "
                      ),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.description,
                            expression: "description",
                          },
                        ],
                        domProps: {
                          value: _vm.description,
                        },
                        on: {
                          input: function input($event) {
                            if ($event.target.composing) return
                            _vm.description = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("label", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.anonymous,
                            expression: "anonymous",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.anonymous)
                            ? _vm._i(_vm.anonymous, null) > -1
                            : _vm.anonymous,
                        },
                        on: {
                          change: function change($event) {
                            var $$a = _vm.anonymous,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.anonymous = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.anonymous = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.anonymous = $$c
                            }
                          },
                        },
                      }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$gettext(
                              "Feedback kann anonym abgegeben werden"
                            )
                          ) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("label", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.commentable,
                            expression: "commentable",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.commentable)
                            ? _vm._i(_vm.commentable, null) > -1
                            : _vm.commentable,
                        },
                        on: {
                          change: function change($event) {
                            var $$a = _vm.commentable,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.commentable = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.commentable = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.commentable = $$c
                            }
                          },
                        },
                      }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$gettext(
                              "Abgegebenes Feedback kann einen Kommentar beinhalten"
                            )
                          ) +
                          "\n                "
                      ),
                    ]),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }